import { CashDeskCloseControlPayment } from './cash-desk-close-control-payment';
import { CashDeskPaymentFilter } from '../cash-desk-payment-filter';

export class CashDeskCloseControlPaymentTotal {

    constructor ( cashDeskPaymentFilter: CashDeskPaymentFilter,
                  cashDeskCloseControlPayments: CashDeskCloseControlPayment[] ) {
        this.paymentId = cashDeskPaymentFilter.Id;
        this.paymentName = cashDeskPaymentFilter.Name;
        this.cashDeskCloseControlPayment = cashDeskCloseControlPayments;
        this.paymentAmount = 0;
        if (cashDeskCloseControlPayments && cashDeskCloseControlPayments.length > 0) {
            cashDeskCloseControlPayments.forEach((item) => {
                this.paymentAmount += item.PaymentAmount;
            });
        }
    }

    public paymentId: number;
    public paymentName: string;
    public paymentDetails: string;
    public paymentAmount: number;
    public cashDeskCloseControlPayment: CashDeskCloseControlPayment[];
    public get text(): string {
        return `${this.paymentName} ${this.paymentAmount}`;
    }
}